<template>
<div class="tw-pt-16">
    <h2 class="tw-text-5xl tw-mb-8">Delivery Tip</h2>
    <div class="tw-flex tw-mb-12 lg:tw-w-1/2 tw-relative">
      <span class="tw-absolute tw-left-1/2 tw-top-4 fa fa-spinner tw-animate-spin tw-text-4xl" v-if="props.settingTip"></span>

      <button
        @click="setPercentage(15)"
        :disabled="props.settingTip"
        :class="['tw-w-1/4 tw-border tw-border-r-0 tw-border-black tw-border-r-0 tw-text-center tw-px-8 tw-py-4 tw-uppercase tw-font-bold tw-rounded-l-full tw-transition-all hover:tw-bg-orange-medium hover:tw-text-white', {'tw-opacity-30': props.settingTip}, {'tw-bg-orange-medium tw-text-white': isFifteen}]">15%</button>
      <button 
        @click="setPercentage(20)"
        :disabled="props.settingTip"
        :class="['tw-w-1/4 tw-border tw-border-r-0 tw-border-black tw-text-center tw-px-8 tw-py-4 tw-uppercase tw-font-bold tw-transition-all hover:tw-bg-orange-medium hover:tw-text-white', {'tw-opacity-30': props.settingTip}, {'tw-bg-orange-medium tw-text-white': isTwnety}]">20%</button>
      <button
        @click="setPercentage(25)"
        :disabled="props.settingTip"
        :class="['tw-w-1/4 tw-border tw-border-black tw-text-center tw-px-8 tw-py-4 tw-uppercase tw-font-bold tw-transition-all hover:tw-bg-orange-medium hover:tw-text-white', {'tw-opacity-30': props.settingTip}, {'tw-bg-orange-medium tw-text-white': isTwentyFive}]">25%</button>

      <div class="tw-w-1/4 tw-relative tw-flex">
        <span :class="['tw-absolute tw-left-4 tw-top-1/2 tw--translate-y-1/2 tw-font-bold tw-flex-1', {'tw-opacity-30': props.settingTip}]">$</span>
        <input 
          type="number"
          v-model="tip"
          v-on:blur="inputSetTip"
          :disabled="props.settingTip"
          :class="['tw-w-full tw-flex-1 tw-border tw-border-black tw-border-l-0 tw-px-10 tw-py-4 tw-uppercase tw-font-bold tw-rounded-r-full tw-transition-all tw-text-2xl tw-appearance-none focus:tw-outline-0 tw-bg-transparent focus:tw-ring-0 focus:tw-border-orange-medium focus:tw-ring-orange-medium', {'tw-opacity-30': props.settingTip}]"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed, watch } from 'vue'
  import { useDebounceFn } from '@vueuse/core'
  import type {PropType} from 'vue';

  import type Basket from '../../classes/Basket';

  const props = defineProps<{ basket: Basket, settingTip: boolean }>();

  const tip = ref("0");

  const emit = defineEmits(['emitTip'])

  onMounted(() => {
    if (props.basket && props.basket.tip) {
      tip.value = props.basket.tip.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  })

  watch(() => props.basket.tip, (basketTip) => {
    if (tip.value.toString() != basketTip.toString()) {
      tip.value = basketTip.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  })

  const debouncedtipSet = useDebounceFn((tip: number) => {
    emit('emitTip', tip)
  }, 500)

  const tipSet = (tip: number) => {
    emit('emitTip', tip)
  }

  const inputSetTip = ((event: Event) => {
     debouncedtipSet(parseFloat(tip.value));
  })

  const setPercentage = ((percent: number) => {
    if (!props.settingTip) {
      tip.value = percentAmount(props.basket.subtotal, percent).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
      debouncedtipSet(parseFloat(tip.value));
    }
  })

  const percentAmount = ((basketTotal: number, percent: number) => {
    return (basketTotal * (percent * 0.01));
  })

  const isFifteen = computed(() => {
    return tip.value == percentAmount(props.basket.subtotal, 15).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
  })

  const isTwnety = computed(() => {
    return tip.value == percentAmount(props.basket.subtotal, 20).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
  })

  const isTwentyFive = computed(() => {
    return tip.value == percentAmount(props.basket.subtotal, 25).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
  })

</script>
